var map = {
	"./acid.png": 7892,
	"./aqua.png": 7251,
	"./autumn.png": 2325,
	"./black.png": 8938,
	"./bumblebee.png": 3470,
	"./business.png": 1789,
	"./cmyk.png": 551,
	"./coffee.png": 3127,
	"./corporate.png": 4750,
	"./cupcake.png": 2627,
	"./cyberpunk.png": 5356,
	"./dark.png": 4503,
	"./dracula.png": 8469,
	"./emerald.png": 5363,
	"./fantasy.png": 3645,
	"./forest.png": 5016,
	"./garden.png": 6792,
	"./halloween.png": 7766,
	"./lemonade.png": 7328,
	"./light.png": 5239,
	"./lofi.png": 9871,
	"./luxury.png": 9296,
	"./night.png": 5281,
	"./pastel.png": 572,
	"./retro.png": 2819,
	"./synthwave.png": 6790,
	"./valentine.png": 3037,
	"./winter.png": 8232,
	"./wireframe.png": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7376;